import { Component, EventEmitter, inject, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { StartExploringEventModel } from 'app/shared/modals/explore-activities-pick-class-modal/start-exploring-event.model';
import { ExploreActivitiesClassInfoModel } from 'app/shared/models/explore-activities-class-info.model';

@Component({
  selector: 'kh-explore-activities-pick-class-modal',
  templateUrl: './explore-activities-pick-class-modal.component.html',
  styleUrls: ['./explore-activities-pick-class-modal.component.less'],
  standalone: false
})
export class ExploreActivitiesPickClassModalComponent {
  private readonly bsModalRef = inject(BsModalRef);

  public classes: ExploreActivitiesClassInfoModel[] = [];
  public courseId: string | null = '';
  public isError = false;
  public selectedClass?: ExploreActivitiesClassInfoModel;

  @Output() public exploringStarted = new EventEmitter<StartExploringEventModel>();

  public selectClass(classItem: ExploreActivitiesClassInfoModel): void {
    this.selectedClass = classItem;
  }

  public startExploring(): void {
    if (!this.selectedClass) {
      this.isError = true;

      return;
    }

    const courseId = this.courseId || this.selectedClass.CourseId;

    const eventData: StartExploringEventModel = {
      classId: this.selectedClass.ClassId,
      courseId
    };

    this.exploringStarted.emit(eventData);
    this.closeModal();
  }

  public closeModal(): void {
    this.bsModalRef.hide();
  }
}
